export type { RatingProps } from './Rating'
export { Rating } from './Rating'
